@import 'vars';
@import 'mixins';

.create-update-directory-contact {
  @include scrollable-container;

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding-top: $padding-small;

  &__inputs {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: $margin-medium;
  }

  &__buttons {
    background: $white;
    display: flex;
    flex-direction: row;
    justify-content: end;
    gap: $padding-large;
    position: sticky;
    bottom: 0;
    padding-top: $padding-large;
  }
}
